export default "__VITE_ASSET__ClBIN_vm__"